import React from "react";

const contactIntro =
  "If you have questions about this Privacy Policy, how your data is used, or wish to contact us for privacy requests, reach out to: ";

const contactEmail = "inquire@hindusrus.org";
const emailTo = `mailto:${contactEmail}`;

const openEmail = (event) => {
  event.preventDefault();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = emailTo;
  } else {
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${contactEmail}`,
      "_blank",
      "noopener,noreferrer"
    );
  }
};

const privacyPolicyConfig = {
  pageTitle: "Privacy Policy",
  sections: [
    {
      id: "section-1",
      title: "SECTION 1 – WHAT DO WE DO WITH YOUR INFORMATION?",
      paragraphs: [
        "When you register or use the Hindus Are Us application, we collect personal information such as your name, email address, or other details you provide while creating an account or interacting with the Service.",
      ],
      subsections: [
        {
          subtitle: "Information from Third-Party Login Services",
          paragraphs: [
            "You may choose to register or log in using third-party services such as Google or Apple. If you do so, we may receive certain information associated with your account, such as your name and email address, in accordance with the privacy settings of those services.",
            "When you use the Service, we may also automatically receive certain technical information such as your device information, IP address, and usage data. This information helps us understand how users interact with the platform and improve the overall experience.",
          ],
        },
      ],
    },
    {
      id: "section-2",
      title: "SECTION 2 – DISCLOSURE",
      paragraphs: [
        "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.",
      ],
      subsections: [],
    },
    {
      id: "section-3",
      title: "SECTION 3 – THIRD-PARTY SERVICES",
      paragraphs: [
        "In general, the third-party providers used by us will only collect, use, and disclose your information to the extent necessary to perform the services they provide to us, such as analytics, hosting, or content delivery.",
        "These third-party service providers may have their own privacy policies regarding how they handle personal information. We encourage you to review their privacy policies to understand how your information may be managed by them.",
        "Some third-party providers may operate in jurisdictions different from where you or we are located. As a result, information processed by these providers may be subject to the laws of those jurisdictions.",
        "Once you leave our Service or interact with content or services provided by third-party platforms, you are no longer governed by this Privacy Policy.",
      ],
      subsections: [
        {
          subtitle: "Links",
          paragraphs: [
            "Our Service may contain links to external websites or services. We are not responsible for the privacy practices of these external sites and encourage users to review their respective privacy policies.",
          ],
        },
      ],
    },
    {
      id: "section-4",
      title: "SECTION 4 – SECURITY",
      paragraphs: [
        "We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.",
      ],
      subsections: [],
    },
    {
      id: "section-5",
      title: "SECTION 5 – CHILDREN'S PRIVACY",
      paragraphs: [
        "Hindus Are Us is intended for use by both children and adults. We are committed to protecting the privacy of children who use our Service.",
        "We collect only limited personal information that is reasonably necessary to enable participation in educational content, quizzes, progress tracking, and other interactive features. This may include a display name, date of birth (to determine age eligibility), username, and password.",
        "We do not knowingly collect personal information from children in violation of applicable laws. If we become aware that personal information relating to a child has been collected improperly, we will take appropriate steps to address the situation.",
        "We do not sell children's personal information and do not use it for targeted advertising. Any disclosure of such information is limited to what is necessary to operate the Service, comply with legal obligations, or protect the safety and security of our users and platform.",
        "We encourage parents and guardians to supervise children's use of digital services and promote safe online practices.",
      ],
      subsections: [],
    },
    {
      id: "section-6",
      title: "SECTION 6 – CHANGES TO THIS PRIVACY POLICY",
      paragraphs: [
        "We reserve the right to modify this privacy policy at any time, so please review it frequently.",
        "Changes and clarifications will take effect immediately upon their posting on the website.",
        "If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.",
        "If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.",
      ],
      subsections: [],
    },
    {
      id: "contact",
      title: "QUESTIONS AND CONTACT INFORMATION",
      paragraphs: [
        React.createElement(
          React.Fragment,
          null,
          contactIntro,
          React.createElement(
            "a",
            {
              href: emailTo,
              className: "privacy-paragraph-email",
              onClick: openEmail,
            },
            contactEmail
          )
        ),
      ],
      subsections: [],
    },
  ],
};

export default privacyPolicyConfig;